import type { enMenuAnalytics } from '../en/menu-analytics';
export const idMenuAnalytics: Record<keyof typeof enMenuAnalytics, string> = {
  'ma.tab': 'Analitik & BOM',
  'ma.title': 'Analitik menu & BOM',
  'ma.description':
    'Bandingkan biaya dan kontribusi menu, periksa rincian bahan baku, dan rencanakan kebutuhan bahan berdasarkan stok gudang.',
  'ma.consumption': 'Lihat pemakaian bahan aktual',
  'ma.noCatalog': 'Analitik menu memerlukan izin untuk melihat katalog menu.',
  'ma.noStock':
    'Jumlah stok gudang memerlukan akses inventori dan paket dengan modul inventori. Biaya resep tetap ditampilkan.',
  'ma.coverage': 'Kelengkapan resep untuk menu aktif',
  'ma.activeItems': 'Item menu aktif',
  'ma.costed': 'Resep dengan biaya lengkap',
  'ma.attention': 'Resep belum ada atau belum lengkap',
  'ma.highCost': 'Biaya bahan di atas 40%',
  'ma.economics': 'Analisis biaya menu',
  'ma.economicsHint':
    'Biaya bahan rata-rata tertimbang saat ini. Kontribusi = harga menu dikurangi biaya resep, sebelum modifier, diskon, tenaga kerja, biaya operasional, dan pajak. Ini bukan laba historis.',
  'ma.menuState': 'Status menu',
  'ma.all': 'Semua status',
  'ma.price': 'Harga menu',
  'ma.cost': 'Biaya / porsi',
  'ma.margin': 'Kontribusi / porsi',
  'ma.recipeState': 'Status resep',
  'ma.status.ready': 'Biaya lengkap',
  'ma.status.missing': 'Belum ada resep',
  'ma.status.inactive': 'Resep nonaktif',
  'ma.status.uncosted': 'Biaya belum lengkap',
  'ma.status.high': 'Biaya bahan > 40%',
  'ma.open': 'Lihat BOM & rencana porsi',
  'ma.search': 'Cari menu, kategori, atau status resep',
  'ma.empty': 'Tambahkan item menu untuk membandingkan biaya dan kebutuhan bahan.',
  'ma.bomFor': 'Rincian bahan baku: {name}',
  'ma.bomHint':
    'Resep dasar per porsi. Rencanakan satu item menu sekaligus; bahan modifier tidak disertakan.',
  'ma.view': 'Kembali ke analisis',
  'ma.edit': 'Edit resep',
  'ma.selectHint':
    'Pilih “Lihat BOM & rencana porsi” dari aksi item menu untuk memeriksa bahan dan stok gudang.',
  'ma.modifiers': 'Biaya resep modifier',
  'ma.modifiersHint':
    'Pilihan opsional maupun wajib mengubah harga akhir dan bahan. Biaya ini terpisah dari resep dasar dan rencana porsi.',
  'ma.option': 'Opsi modifier',
  'ma.priceDelta': 'Penyesuaian harga',
  'ma.inactiveHint':
    'Resep ini nonaktif. Aktifkan melalui editor resep sebelum merencanakan kebutuhan bahan.',
  'ma.missingHint':
    'Belum ada rincian bahan baku. Tambahkan resep dengan bahan inventori untuk menghitung biaya dan kebutuhan porsi.',
  'ma.portions': 'Rencana porsi',
  'ma.portionsError': 'Masukkan bilangan bulat dari 1 hingga 10.000.',
  'ma.location': 'Lokasi stok',
  'ma.allLocations': 'Semua lokasi aktif',
  'ma.stockHint':
    'Perkiraan stok tidak mencakup karantina serta lokasi atau bahan nonaktif. Lot ditahan atau kedaluwarsa mungkin masih tercakup. Kebutuhan menu lain, transfer, dan reservasi stok tidak dihitung; periksa stok layak pakai sebelum persiapan.',
  'ma.batchCost': 'Rencana biaya bahan',
  'ma.batchMargin': 'Rencana kontribusi',
  'ma.capacity': 'Perkiraan porsi dari stok',
  'ma.ingredient': 'Bahan / SKU',
  'ma.perPortion': 'Per porsi',
  'ma.required': 'Kebutuhan',
  'ma.onHand': 'Stok tersedia',
  'ma.shortage': 'Kekurangan',
  'ma.costShare': 'Porsi biaya resep',
  'ma.unknownHint':
    'Tanda pisah berarti nilai tidak tersedia, belum lengkap, atau di luar rentang angka yang didukung. Biaya yang belum ada tidak dianggap nol. Perencanaan tidak mereservasi atau mengurangi stok.',
  'ma.sales': 'Menu terlaris',
  'ma.salesHint':
    'Penjualan dari tagihan lunas, {from} hingga {to} ({zone}). Menu teratas memakai nama saat penjualan; biaya resep saat ini tidak diterapkan pada penjualan historis.',
  'ma.salesShare': 'Porsi penjualan kotor',
  'md.open': 'Lihat detail menu',
  'md.back': 'Kembali ke menu',
  'md.notFound': 'Item menu tidak ditemukan di cabang ini.',
  'md.analytics': 'Analitik',
  'md.bom': 'Build of Material',
  'md.profitability': 'Profitabilitas',
  'md.tabs': 'Tab detail item menu',
  'md.days': '{days} hari',
  'md.rangeError':
    'Pilih tanggal valid dan berurutan hingga hari ini dengan rentang maksimal 366 hari.',
  'md.noReports': 'Peran Anda tidak dapat melihat laporan penjualan cabang ini.',
  'md.sold': 'Porsi terjual',
  'md.salesContribution': 'Kontribusi penjualan cabang',
  'md.orders': 'Pesanan dengan menu ini',
  'md.heatmap': 'Kontribusi penjualan harian',
  'md.heatmapHint':
    'Setiap kotak adalah satu hari bisnis. Kotak lebih gelap berarti lebih banyak porsi terjual. Pilih hari atau gunakan tombol panah untuk melihat rinciannya.',
  'md.dayLabel': '{quantity} porsi pada {date}',
  'md.less': 'Sedikit',
  'md.more': 'Banyak',
  'md.promoTitle': 'Permintaan saat promosi',
  'md.promoHint':
    'Permintaan pada hari dalam jadwal promosi aktif yang ditautkan ke menu ini. Mencakup hari tanpa penjualan dan hari parsial. Dibandingkan dengan hari lain dalam rentang ini, bukan bukti dampak promosi. Perubahan jadwal lama dan promosi nonaktif tidak direkonstruksi; promosi yang tumpang tindih berbagi penjualan.',
  'md.noPromos': 'Tidak ada jadwal promosi aktif yang ditautkan ke menu ini pada periode terpilih.',
  'md.promoAverage': 'Porsi / hari promosi',
  'md.normalAverage': 'Porsi / hari lainnya',
  'md.demandChange': 'Perbedaan permintaan teramati',
  'md.promotion': 'Promosi',
  'md.window': 'Periode pengamatan',
  'md.observedDays': 'Hari',
  'md.perDay': 'Porsi / hari',
  'md.modifierTitle': 'Preferensi kepedasan & tambahan',
  'md.modifierHint':
    'Pilihan yang tercatat saat penjualan, dibobot berdasarkan porsi. Setiap grup modifier ditampilkan terpisah. Pilihan ganda dapat membuat jumlah persentase melebihi 100%. Opsi yang tidak dipilih tidak dihitung.',
  'md.noModifiers':
    'Belum ada pilihan modifier pada penjualan lunas menu ini dalam periode tersebut.',
  'md.selectionShare': 'Persentase porsi',
  'md.addonSales': 'Penjualan tambahan',
  'md.salesScope':
    'Hanya tagihan lunas berdasarkan tanggal bisnis di {zone}. Termasuk harga modifier, sebelum pajak dan biaya layanan. Berdasarkan ID menu, termasuk penjualan dengan nama lama.',
  'md.noSales': 'Belum ada penjualan lunas pada periode ini.',
  'md.currentProfit': 'Analisis biaya resep saat ini',
  'md.marginPercent': 'Margin kontribusi',
  'md.costMissing':
    'Lengkapi dan aktifkan resep serta catat biaya bahan untuk menghitung profitabilitas.',
  'md.recordedProfit': 'Kontribusi penjualan tercatat',
  'md.recordedHint':
    'Penjualan historis dikurangi pemakaian bahan yang tercatat lengkap untuk baris pesanan yang sama. Termasuk resep modifier yang dikonfigurasi. Tidak mencakup tenaga kerja, operasional, biaya platform, dan resep bahan yang belum dikonfigurasi. Ini kontribusi setelah biaya bahan, bukan laba bersih.',
  'md.coverage': 'Porsi dengan biaya lengkap',
  'md.recordedCost': 'Biaya bahan tercatat',
  'md.recordedContribution': 'Total kontribusi setelah bahan',
  'md.incompleteCost':
    'Sebagian porsi terjual belum memiliki pemakaian lengkap atau masih tertunda. Total kontribusi belum diketahui; bagian yang tercatat ditampilkan di bawah.',
  'md.coveredSales': 'Penjualan dengan pemakaian lengkap',
  'md.coveredContribution': 'Kontribusi penjualan dengan biaya lengkap saja',
  'md.currentBom': 'Rincian bahan baku saat ini',
  'md.version': 'Versi {version}',
  'md.history': 'Riwayat versi BOM',
  'md.historyHint':
    'Menyimpan resep membuat versi tetap berisi bahan, jumlah, catatan, dan status aktif. Memulihkan versi lama menyimpannya sebagai versi baru; riwayat tetap dipertahankan.',
  'md.noHistory':
    'Resep ini dibuat sebelum pencatatan versi. Isi saat ini akan disimpan sebagai versi dasar saat diedit berikutnya; versi terdahulu tidak dapat direkonstruksi.',
  'md.chooseVersion': 'Versi tersimpan',
  'md.restored': 'BOM terdahulu disimpan sebagai versi baru.',
  'md.restore': 'Pulihkan sebagai versi baru',
  'md.newest': 'Versi terbaru',
  'md.older': 'Versi lebih lama',
  'md.baseline':
    'Versi dasar diambil sebelum edit pertama yang tercatat. Biaya berdasarkan waktu pengambilan, bukan tanggal pembuatan versi asli.',
  'md.snapshotHint':
    'Biaya bahan tersimpan merupakan potret saat versi ini disimpan. Biaya gudang saat ini mungkin berbeda.',
  'md.savedCost': 'Biaya saat dicatat',
  'md.portions': '{quantity} porsi',
};
